// Clears the service-worker registrations and the Cache Storage, then reloads
// — the navigation menu's "clear cache" item.
//
// This module also used to compare the loaded `main.<hash>.js` with a copy in
// localStorage on every start and reload on a mismatch. Vite names the entry
// `assets/index-<hash>.js`, so that check had matched nothing since the move
// off CRA, and it only ever ran at start, when index.html is fresh anyway
// (served no-cache). A tab left open across a deploy is told by
// src/utils/appVersion.js instead (CREW-1289).
class AssetHashChecker {
  clearCacheAndReload() {
    Promise.resolve().then(async () => {
      try {
        if ('serviceWorker' in navigator) {
          const registrations = await navigator.serviceWorker.getRegistrations();
          await Promise.all(registrations.map(reg => reg.unregister()));
        }
        
        if ('caches' in window) {
          const cacheNames = await caches.keys();
          await Promise.all(cacheNames.map(name => caches.delete(name)));
        }
        
        window.location.reload(true);
      } catch (error) {
        console.error('❌ Cache clear failed:', error);
      }
    });
  }

  manualClear() {
    this.clearCacheAndReload();
  }
}

export default new AssetHashChecker();
